import { Card, FullWidthLayout } from '@versita/frontend/campus-ui-web';

import { useUserWidget } from '../../hooks/useUserWidget';

import { StudentTimetableList } from '../../organisms/StudentTimetableList';
import { AdminNav } from '../../molecules/AdminNav';

/**
An admin dashboard for timetable admins/managers
*/
export const TimetableAdminDashboard = () => {
  const userWidget = useUserWidget();

  return (
    <FullWidthLayout
      userWidget={userWidget}
      heading={{
        title: 'Admin Dashboard',
        subtitle: 'Student Timetables',
      }}
    >
      <AdminNav />
      <h2>Student Timetables</h2>
      <Card $fullWidth>
        <StudentTimetableList />
      </Card>
    </FullWidthLayout>
  );
};

export default TimetableAdminDashboard;
